// API client — прокидывает Telegram InitData в каждый запрос
// Window.Telegram type defined in telegram.d.ts
function getAuthHeader() {
    const initData = window.Telegram?.WebApp?.initData;
    if (initData) {
        return { "X-Telegram-Init-Data": initData };
    }
    // Dev fallback — используй X-Dev-User-Id если нет TG
    const devId = import.meta.env.VITE_DEV_USER_ID;
    if (devId) {
        return { "X-Dev-User-Id": devId };
    }
    return {};
}
async function request(path, options = {}) {
    const controller = new AbortController();
    // 15s timeout — enough for slow 3G + match processing
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
        const res = await fetch(`/api${path}`, {
            ...options,
            signal: controller.signal,
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeader(),
                ...options.headers,
            },
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body.error ?? `HTTP ${res.status}`);
        }
        return res.json();
    }
    catch (e) {
        if (e.name === "AbortError") {
            throw new Error("Request timed out. Check your connection.");
        }
        throw e;
    }
    finally {
        clearTimeout(timer);
    }
}
export const api = {
    get: (path) => request(path),
    post: (path, body) => request(path, { method: "POST", body: JSON.stringify(body ?? {}) }),
    patch: (path, body) => request(path, { method: "PATCH", body: JSON.stringify(body ?? {}) }),
};
